import { createAsyncThunk } from "@reduxjs/toolkit";
import { paths } from "../schema";
import Client4 from "../client4";
import { SaveContent } from "@/types/content";

import OSS from "ali-oss";
import { v4 as uuid } from 'uuid';
type ControlNetAction = {
  type: "SET_CONTROLNET_IMAGE";
  controlNetId: string;
};

type InitialImageAction = {
  type: "SET_INITIAL_IMAGE";
};

type NodesAction = {
  type: "SET_NODES_IMAGE";
  nodeId: string;
  fieldName: string;
};

type CanvasInitialImageAction = {
  type: "SET_CANVAS_INITIAL_IMAGE";
};

type CanvasMergedAction = {
  type: "TOAST_CANVAS_MERGED";
};

type CanvasSavedToGalleryAction = {
  type: "TOAST_CANVAS_SAVED_TO_GALLERY";
};

type UploadedToastAction = {
  type: "TOAST_UPLOADED";
};

type StructureAction = {
  type: "SET_STRUCTURE_IMAGE";
};

type StyleAction = {
  type: "SET_STYLE_IMAGE";
};

export type PostUploadAction = ControlNetAction | InitialImageAction | NodesAction | CanvasInitialImageAction | CanvasMergedAction | CanvasSavedToGalleryAction | UploadedToastAction | StructureAction | StyleAction;

type UploadImageArg = paths["/api/v1/images/"]["post"]["parameters"]["query"] & {
  file: File;
  postUploadAction?: PostUploadAction;
  imageType?: string;
};

type IntermediateUploadResult = {
  image_url: string;
  is_intermediate: true;
};

export const imageUploaded = createAsyncThunk("api/imageUploaded", async (arg: UploadImageArg, { rejectWithValue }) => {
  const { file, image_category, is_intermediate, session_id, imageType, postUploadAction } = arg;

  const formData = new FormData();
  formData.append("file", file);
  try {
    if (is_intermediate) {
      const client = new OSS({
        accessKeyId: "LTAI5t98Psjz7n8RzAPv4dGy",
        accessKeySecret: "deHrAlumrB7Gm89Ys2cRbtmwMvon7u",
        region: "oss-cn-beijing",
        bucket: "bcgang",
      });

      const result = await client.put("upload/" + uuid() + "_" + file.name, file);
      return {
        image_url: result.url,
        is_intermediate: true,
      } as IntermediateUploadResult;
    }
    const response = await fetch("https://images.aldgptai.com/upload", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Server responded with status code ${response.status}`);
    }
    const data = await response.json();
    if (data && data.file_name) {
      console.log("文件上传成功，文件名:", data.file_name);
      const { width: image_width, height: image_height } = await getImageSizeFromFile(file);
      const saveParams = {
        image_url: data.image_url,
        ref_structure: "",
        ref_structure_weight: 1,
        ref_style: "",
        style: "",
        prompt: "",
        negative_prompt: "",
        width: image_width,
        height: image_height,
        generate_type: "",
        user_id: session_id,
        thumbnail_url: data.thumbnail_url,
        type: "Upload",
        image_name: data.file_name,
      };
      const result = await Client4.saveContent(saveParams as SaveContent);
      result.image_name = result.id;
      return result;
    } else {
      console.log("文件上传失败，错误信息:", data.error);
      return rejectWithValue({ arg, error: data.error });
    }
  } catch (error) {
    console.error("File upload failed:", error);
    return rejectWithValue({ arg, error });
  }
});

export const getImageSizeFromBase64 = (base64: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
  });
};

export const getImageSizeFromFile = (file: File): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(img.src); // 释放对象URL
    };
  });
};

function getFileExtension(file: File) {
  const parts = file.name.split(".");
  return parts.length > 1 ? parts.pop()?.toLowerCase() : "";
}
